import { render, staticRenderFns } from "./Refund2Page.vue?vue&type=template&id=63473604"
import script from "./Refund2Page.vue?vue&type=script&lang=js"
export * from "./Refund2Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports